module.exports = __webpack_public_path__ + "img/express-flower-gel-double-tensor-7-large.3c9689c3.png";